import {Controller} from "@hotwired/stimulus";
import { toast } from "sonner";

import Debug from 'debug';

export const name = 'toast';

const debug = Debug(`app:${name}`);

export default class extends Controller<HTMLDivElement> {

    connect() {
        const e = this.element;
        debug('toast connected', e);
        const message = JSON.parse(e.dataset['message']!) as {text: string, type: 'success' | 'info' | 'error' | 'warning'};
        debug('message', message);
        //prevent replay on navigation back

        e.parentNode!.removeChild(e);
        setTimeout(() => {
            toast[message.type](message.text);
        }, 100);
    }

    disconnect() {

    }
}